<template>
  <div class="container">
    <!-- Modales -->
    <b-modal no-close-on-backdrop centered ref="entrega-documento-modal" title="" hide-footer id="modalC" size="xl">
      <div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(postDocumento)">
            <ModalEntregaDocumento
              accepted-file-types="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              :currentDocumento="currentDocumento"
              :cotejo="cotejo"
              @submit.prevent
            />
          </form>
        </ValidationObserver>
      </div>
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-img" title="" hide-footer id="modaldi" size="xl">
      <ModalPreviewImg :currentDocumento="currentDocumento" />
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-pdf" title="" hide-footer id="modaldf" size="xl">
      <ModalPreviewPDF :currentDocumento="currentDocumento" />
    </b-modal>

    <!-- Template -->
    <h4 class="cardD">Documentos digitales</h4>

    <b-table ref="table" hover :fields="fieldsDocumentos" :items="documentosToShow">
      <template #cell(descripcion)="{ item }">
        <div v-if="item.tipo === 'Otro'">
          <div v-b-tooltip.hover :title="item.descripcion">
            {{ item.tipo + " - " + item.descripcion }}
          </div>
        </div>
        <div v-else-if="item.tipo === 'Anexo'">
          {{ item.nombre }}
        </div>
        <div v-else>
          {{ item.tipo }}
        </div>
      </template>

      <template #cell(tieneDocumento)="{ item }">
        {{ item.documento && item.documento !== "" ? "✔" : "X" }}
      </template>

      <template #cell(acciones)="{ item }">
        <b-button
          v-if="cotejo.id_estatus === 19 || cotejo.id_estatus === 75 || cotejo.id_estatus !== 21"
          variant="warning"
          size="sm"
          v-b-tooltip.hover
          title="Editar"
          @click="openEditDocumentoModal(item)"
          class="editBtn"
        >
          <b-icon-upload />
        </b-button>
        <b-button
          v-if="item.documento"
          variant="primary"
          size="sm"
          v-b-tooltip.hover
          title="Vista previa"
          @click="previewDocumento(item)"
          class="editBtn"
        >
          <b-icon-eye />
        </b-button>
      </template>
    </b-table>

    <div class="mt-4">
      <div class="">
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="isButtonDisabled">
          {{ buttonText }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPreviewImg from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewImg.vue";
import ModalPreviewPDF from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewPDF.vue";
import ModalEntregaDocumento from "@/views/clients/procesos/cotejo/infoBase/modales/ModalEntregaDocumento.vue";

import { DocumentosApi, FuncionesApi, ValidacionesDocumentosApi } from "@/api";
import loadingMixin from "@/mixins/loadingMixin";

export default {
  name: "DocumentosDigitales",

  components: {
    ModalEntregaDocumento,
    ModalPreviewImg,
    ModalPreviewPDF,
  },

  props: {
    cotejo: { type: Object },
  },

  mixins: [loadingMixin],

  computed: {
    buttonText() {
      return this.cotejo.staff ? "Validar" : "Continuar";
    },

    isButtonDisabled() {
      return false;
      // return this.cotejo.id_estatus != 19 && this.cotejo.id_estatus != 75;
    },

    allDocuments() {
      // Combine cotejo documents with locally added ones
      const combined = [...(this.cotejo.documentos || []), ...this.localAddedDocuments];
      // Remove duplicates by ID just in case
      const unique = [];
      const map = new Map();
      for (const item of combined) {
        if (!map.has(item.id)) {
          map.set(item.id, true);
          unique.push(item);
        }
      }
      return unique;
    },

    documentosToShow() {
      const uniqueCatIds = [76, 131];
      const copyDocumentIds = this.validaciones
        .filter((v) => v.documentos_copia_certificada_id)
        .map((v) => v.documentos_copia_certificada_id);

      const filtered = this.allDocuments.filter((doc) => {
        const isUnique = uniqueCatIds.includes(Number(doc.cat_documentos_id));
        const isCopy = copyDocumentIds.includes(doc.id);
        return isUnique || isCopy;
      });

      return filtered.sort((a, b) => {
        const idA = Number(a.cat_documentos_id);
        const idB = Number(b.cat_documentos_id);

        const priority = { 76: 1, 131: 2 };

        const pA = priority[idA] || 999;
        const pB = priority[idB] || 999;

        return pA - pB;
      });
    },

    documentosCompletos() {
      if (this.documentosToShow.length === 0) return false;
      return this.documentosToShow.every((doc) => doc.documento && doc.documento !== "");
    },
  },

  created() {
    this.toggleOnLoading();
    this.initValidacionesYDocumentos()
      .catch((error) => {
        this.showErrorToast("No se pudieron cargar los documentos. Intente más tarde.");
        console.log(error);
      })
      .finally(this.toggleOffLoading);
  },

  data() {
    return {
      fieldsDocumentos: [
        { key: "descripcion", label: "Descripción", class: "text-center" },
        { key: "tieneDocumento", label: "Documento Cargado", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ],
      confirmAceptacion: false,

      currentDocumento: {},
      validaciones: [],
      localAddedDocuments: [],
    };
  },

  methods: {
    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async initValidacionesYDocumentos() {
      const originalCatIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 29, 73];
      const originals = this.cotejo.documentos.filter(
        (doc) => originalCatIds.includes(Number(doc.cat_documentos_id)) && doc.numero_documento !== 2,
      );

      await this.fetchOrCreateValidaciones(originals);
      await this.fetchOrCreateCopiasCertificadas(originals);
      await this.ensureUniqueDocs();
    },

    async fetchOrCreateValidaciones(originals) {
      const promesas = originals.map(async (doc) => {
        try {
          const res = await ValidacionesDocumentosApi.getValidacionesDocumentosCliente(doc.id);
          const validacion = res.data ? res.data : res;
          this.validaciones.push(validacion);
        } catch (error) {
          if (error.status === 404) {
            const nuevaValidacion = { documentos_cliente_id: doc.id };
            const resCreate = await ValidacionesDocumentosApi.create(nuevaValidacion);
            const validacionCreate = resCreate.data ? resCreate.data : resCreate;
            this.validaciones.push(validacionCreate);
          } else {
            console.error("Error obteniendo validación para documento:", doc.id, error);
          }
        }
      });
      await Promise.all(promesas);
    },

    async fetchOrCreateCopiasCertificadas(originals) {
      const promesas = originals.map(async (doc) => {
        const validacion = this.validaciones.find((v) => v.documentos_cliente_id === doc.id);
        if (validacion && !validacion.documentos_copia_certificada_id) {
          try {
            const payload = {
              cat_documentos_id: doc.cat_documentos_id,
              cotejos_id: this.cotejo.id,
              nombre: `Copia certificada - ${doc.nombre}`,
              descripcion: `PDF de la copia certificada de ${doc.tipo || "documento"}`,
              activo: 1,
              documento: "",
            };
            const resCreate = await DocumentosApi.create(payload);
            const newDoc = resCreate.data ? resCreate.data : resCreate;
            newDoc.tipo = `Copia Certificada - ${doc.tipo || "Documento"}`;
            this.localAddedDocuments.push(newDoc);

            validacion.documentos_copia_certificada_id = newDoc.id;
            await ValidacionesDocumentosApi.edit(validacion.id, validacion);
          } catch (error) {
            console.error("Error creando copia certificada:", error);
          }
        } else if (validacion && validacion.documentos_copia_certificada_id) {
          // fetch it if not in cotejo.documentos
          const alreadyExists = this.allDocuments.find((d) => d.id === validacion.documentos_copia_certificada_id);
          if (!alreadyExists) {
            try {
              const res = await DocumentosApi.detail(validacion.documentos_copia_certificada_id);
              const existingDoc = res.data ? res.data : res;
              existingDoc.tipo = `Copia Certificada - ${doc.tipo || "Documento"}`;
              this.localAddedDocuments.push(existingDoc);
            } catch (error) {
              console.error("Error fetching existing copia certificada:", error);
            }
          }
        }
      });
      await Promise.all(promesas);
    },

    async ensureUniqueDocs() {
      const uniqueDocs = [
        { id: 131, nombre: "Acta en PDF", desc: "Acta en PDF de cotejo", tipo: "Acta en PDF" },
        { id: 76, nombre: "Acuse de entrega", desc: "Acuse de entrega de documentos", tipo: "Acuse de entrega" },
      ];

      for (const item of uniqueDocs) {
        const exists = this.allDocuments.find((d) => Number(d.cat_documentos_id) === item.id);
        if (!exists) {
          try {
            const payload = {
              cat_documentos_id: item.id,
              cotejos_id: this.cotejo.id,
              nombre: item.nombre,
              descripcion: item.desc,
              activo: 1,
              documento: "",
            };
            const resCreate = await DocumentosApi.create(payload);
            const newDoc = resCreate.data ? resCreate.data : resCreate;
            newDoc.tipo = item.tipo;
            this.localAddedDocuments.push(newDoc);
          } catch (error) {
            console.error(`Error creando documento único ${item.nombre}:`, error);
          }
        }
      }
    },

    openEditDocumentoModal(documento) {
      this.$refs["entrega-documento-modal"].show();
      this.currentDocumento = documento;
    },

    hideEditDocumentoModal() {
      this.$refs["entrega-documento-modal"].hide();
    },

    postDocumento() {
      this.hideEditDocumentoModal();
      this.sendCurrentDocumentoToAzureStorage();
    },

    async sendCurrentDocumentoToAzureStorage() {
      try {
        this.toggleOnLoading();

        const formData = new FormData();
        this.currentDocumento.nombre = this.currentDocumento.file.name;
        formData.append("file", this.currentDocumento.file);

        const path = await FuncionesApi.file(this.cotejo.id, "documentosCotejos", formData, {});

        this.currentDocumento.documento = path;
        this.updateDocumentoBD();
      } catch (error) {
        this.showErrorToast("Error al mandar el archivo. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    async updateDocumentoBD() {
      try {
        this.toggleOnLoading();

        await DocumentosApi.edit(this.currentDocumento.id, {
          documento: this.currentDocumento.documento,
          cat_documentos_id: this.currentDocumento.cat_documentos_id,
          auto_referencia: this.currentDocumento.auto_referencia,
          descripcion: this.currentDocumento.descripcion,
          paginas: parseInt(this.currentDocumento.paginas),
          copias_certificadas: parseInt(this.currentDocumento.copias_certificadas),
          nombre: this.currentDocumento.nombre,
          activo: 1,
        });
      } catch (error) {
        this.showErrorToast("Error al actualizar el documento. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    previewDocumento(item) {
      this.currentDocumento = item;
      const isCurrentDocumentImage = this.isCurrentDocumentAnImage();
      if (isCurrentDocumentImage) {
        this.$refs["documento-modal-preview-img"].show();
      } else {
        this.$refs["documento-modal-preview-pdf"].show();
      }
    },

    isCurrentDocumentAnImage() {
      let documentoSeparatedByDots = this.currentDocumento.nombre.split(".");
      let extensionDocumento = documentoSeparatedByDots[documentoSeparatedByDots.length - 1];
      const imageExtensions = ["jpg", "JPG", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "avif"];
      if (imageExtensions.includes(extensionDocumento)) {
        return true;
      }
      return false;
    },
  },
};
</script>
